// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rxp9AN2NR1UhGwAC {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 28px;
  background: rgb(226, 55, 36);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  z-index: 1200;
  pointer-events: none;
  transform: translateY(-100%);
  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1);
}

.sdezpc4P40P1KkHq {
  transform: translateY(0);
  pointer-events: auto;
}

.dBF6bXeKKo47VutL {
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chef/components/OfflineIndicator/OfflineIndicator.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".banner {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 28px;\r\n  background: rgb(226, 55, 36);\r\n  color: #ffffff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  z-index: 1200;\r\n  pointer-events: none;\r\n  transform: translateY(-100%);\r\n  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n\r\n.visible {\r\n  transform: translateY(0);\r\n  pointer-events: auto;\r\n}\r\n\r\n.bannerText {\r\n  pointer-events: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var banner = `Rxp9AN2NR1UhGwAC`;
export var visible = `sdezpc4P40P1KkHq`;
export var bannerText = `dBF6bXeKKo47VutL`;
export default ___CSS_LOADER_EXPORT___;
